import { render, staticRenderFns } from "./SettingsTeam.vue?vue&type=template&id=9ecac0ca&scoped=true&"
import script from "./SettingsTeam.vue?vue&type=script&lang=js&"
export * from "./SettingsTeam.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTeam.vue?vue&type=style&index=0&id=9ecac0ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecac0ca",
  null
  
)

export default component.exports